var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { getAutomation, getDebug } from '@citrus/runtime';
import { cx, css as emotionCss } from 'emotion';
import map from 'lodash/map';
import isEqual from 'lodash/isEqual';
import { isNotNullOrEmpty } from '@pcty/utils';
import { Styled } from './Sortable.styled';
import { staticItemChild } from '../styles';
import StaticGroup from './_StaticGroup';
import getItemIndexMap from '../utils/getItemIndexMap';
import StaticRow from './StaticRow';
import StaticColumn from './StaticColumn';
import StaticHeaderColumn from './StaticHeaderColumn';
import StaticHeaderRow from './StaticHeaderRow';
var VERSION = '2.5.0';
var SortableStatic = /** @class */ (function (_super) {
    __extends(SortableStatic, _super);
    function SortableStatic(props) {
        var _this = _super.call(this, props) || this;
        _this.dividerOnClick = _this.dividerOnClick.bind(_this);
        _this.renderItem = _this.renderItem.bind(_this);
        _this.state = {
            itemIndexMap: getItemIndexMap(props.data),
            inactiveIndexes: [],
            data: props.data,
        };
        return _this;
    }
    SortableStatic.getDerivedStateFromProps = function (props, state) {
        if (!isEqual(state.data, props.data)) {
            return {
                itemIndexMap: getItemIndexMap(props.data),
                data: props.data,
            };
        }
        return {};
    };
    SortableStatic.prototype.dividerOnClick = function (index) {
        var _a, _b;
        if (((_a = this.state.inactiveIndexes) === null || _a === void 0 ? void 0 : _a.indexOf(index)) >= 0) {
            this.setState({ inactiveIndexes: (_b = this.state.inactiveIndexes) === null || _b === void 0 ? void 0 : _b.filter(function (x) { return x !== index; }) });
            return;
        }
        this.setState({ inactiveIndexes: __spreadArray(__spreadArray([], this.state.inactiveIndexes, true), [index], false) });
    };
    SortableStatic.prototype.render = function () {
        var _a;
        var _this = this;
        var children = map(this.props.data, function (x) { return _this.renderItem(x); });
        var classes = cx((_a = {},
            _a[emotionCss(this.props.css)] = isNotNullOrEmpty(this.props.css),
            _a), this.props.className || '');
        return (React.createElement(Styled.StaticSortable, __assign({}, getAutomation(this.props.automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', this.props.__TYPE, VERSION), { className: classes }),
            React.createElement(Styled.StaticGroup, null,
                this.props.renderHeader && this.props.renderHeader(),
                renderAccordionChildren(children, this.state.inactiveIndexes, this.dividerOnClick))));
    };
    SortableStatic.prototype.renderItem = function (item, child) {
        var _this = this;
        var _a;
        if (child === void 0) { child = false; }
        if ('items' in item) {
            return (React.createElement(StaticGroup, { automationId: this.props.id, colSpan: this.props.columnCount, item: item, key: this.props.id + '-group-' + item.id }, map(item.items, function (x) { return _this.renderItem(x, true); })));
        }
        return (React.createElement(Styled.StaticItem, { className: child ? emotionCss(staticItemChild) : '', key: this.props.id + '-' + item.id }, !!this.props.renderItem ? this.props.renderItem(item, (_a = this.state.itemIndexMap) === null || _a === void 0 ? void 0 : _a[item.id]) : item));
    };
    SortableStatic.Row = StaticRow;
    SortableStatic.Column = StaticColumn;
    SortableStatic.HeaderRow = StaticHeaderRow;
    SortableStatic.HeaderColumn = StaticHeaderColumn;
    SortableStatic.defaultProps = {
        columnCount: 1,
        __TYPE: 'SortableStatic',
    };
    return SortableStatic;
}(Component));
var renderAccordionChildren = function (children, inactiveIndexes, dividerOnClick) {
    return React.Children.map(children, function (child, index) {
        if (child.props.__TYPE === 'StaticGroup') {
            return React.cloneElement(child, {
                onClick: dividerOnClick,
                index: index,
                active: inactiveIndexes.indexOf(index) < 0,
            });
        }
        return child;
    });
};
export default SortableStatic;
